import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Starfield from '@/views/situationRoom/animation/star.vue';
import { scrambleTextEffect, runLoadingAnimation, runCircleAnimation } from '@/views/situationRoom/animation';
export default {
  name: 'LoadingScreen',
  components: {
    Starfield: Starfield
  },
  props: {
    lineCount: {
      type: Number,
      default: 2
    },
    boxCount: {
      type: Number,
      default: 2
    }
  },
  mounted: function mounted() {
    var _this = this;
    runLoadingAnimation();
    runCircleAnimation();
    setTimeout(function () {
      var spans = _this.$refs.scrambleText.querySelectorAll('span');
      spans.forEach(function (span) {
        var text = span.dataset.text;
        scrambleTextEffect(span, text, 5000);
      });
    }, 1000);
  }
};